import React, { Component } from "react";
import { connect } from "react-redux";
import withAppShell from "../../../hoc/withAppShell/WithAppShell";
import { SignUpActions } from "../../../../store";
import SignUp from "./SignUp";
import lodashUtil from 'lodash'
import { getKeyFromLS } from '../../../../utils/LocalStorageUtil'
import {
  MuiButton,
  MuiTextField,
  MuiEmailIcon,
  MuiPhoneIcon,
  MuiInputAdornment,
  MuiPersonIcon,
  MuiTypography,
  muiWithStyles,
  MuiGrid,
  MuiReportProblemIcon,
  MuiCheckbox
} from "../../../ui/MaterialUIComponents";

class SignUpContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }
  componentWillMount() {
    let i18n, systemConfig;
    if (this.props.i18n === undefined || lodashUtil.isEmpty(this.props.i18n)) {
      i18n = getKeyFromLS("i18n");
    } else {
      i18n = this.props.i18n
    }
    if (this.props.systemConfig === undefined || lodashUtil.isEmpty(this.props.systemConfig)) {
      systemConfig = getKeyFromLS("systemConfig");
    } else {
      systemConfig = this.props.systemConfig
    }
    this.setState({
      i18n: i18n,
      systemConfig: systemConfig
    })
  }
  render() {
    return (this.state.systemConfig.isRegistrationsOpen ? <SignUp {...this.props} {...this.state} /> : <MuiGrid container style={{ marginTop: '64px' }}>
      <embed src={this.state.i18n.signup.registrationsClosedRedirectLink} style={{ width: "100vw", height: "85vh" }}></embed>
      {/* <span  dangerouslySetInnerHTML={{__html:this.state.i18n.signup.registrationsClosedDiscription}}></span> */}
    </MuiGrid>)
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    signUp: data => dispatch(SignUpActions.signUp(data))
  };
};

const mapStateToProps = (state) => {
  return {
    //user : state.user.user
    signUpInProgress: state.signUpReducer.signUpInProgress,
    i18n: state.i18nMessages.i18n,
    systemConfig: state.systemConfig.systemConfig
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAppShell(SignUpContainer, { properties: { isProtected: false } }));


//<embed  src="https://docs.google.com/forms/d/e/1FAIpQLScXOqf2bbszUzLSt2YlKnK7BtWS24ZOrwZc9Mo3GFWoDEBoOw/viewform?embedded=true" style={{width:"100vw",height:"85vh",marginTop:"64px"}}></embed>